import React from 'react';
import {
    DateTimeRange,
    RSVPTel,
    RSVPLink
} from '../events_common';
import LazyImg from '../lazy_img';
import { handleLinkKeyDownWithFunction } from '../utils';
import { getLocationObject, RA_73_STERILIZE_HTML_STRING } from '../utils.jsx';

export const DefaultEvent = (props) => {
    const {
        title,
        startDateTime,
        endDateTime,
        locationAddress,
        locationVenueName,
        description,
        image,
        rsvpType,
        rsvpInfo,
        rsvpLink,
        labelRsvpButton,
        labelRsvp,
        labelDetailsButton,
        shouldDisplayEventDetailsLink,
        slug,
        isExternalUrlWithReference,
        handleDetailsLinkClick
    } = props;

    const locationObject = getLocationObject(locationAddress);

    return (
        <div className="hs-event col-xs-12">
            <div className="row">
                <div className="col-sm-3 col-md-3 col-lg-3 col-xs-12 hidden-xs">
                    <div className="mask">
                        {image && <LazyImg src={image} alt="event"/>}
                    </div>
                </div>
                <div className="col-sm-9 col-md-9 col-lg-9 col-xs-12">
                    <h3 className="hs-event__title">{title}</h3>
                    <DateTimeRange start={startDateTime} end={endDateTime} />
                    <p className="hs-event__location">
                        {
                            !locationObject.isVirtual ?
                                <a href={locationObject.gMapsUrl}
                                    target="_blank"
                                >
                                    {locationObject.address}
                                </a> :
                                <span>{locationObject.address}</span>
                        }
                    </p>
                    <p className="hs-event__location_venue_name">{locationVenueName}</p>
                    <div
                        className="hs-event__details"
                        dangerouslySetInnerHTML={{__html: RA_73_STERILIZE_HTML_STRING(description) }}
                    />
                    {rsvpType && (
                        rsvpType === "phone" ?
                            <RSVPTel text={rsvpInfo} link={rsvpLink} labelRsvp={labelRsvp} eventName={title} />
                            :
                            <RSVPLink
                                link={rsvpLink}
                                linkType={rsvpType}
                                labelRsvpButton={labelRsvpButton}
                                eventName={title}
                                slug={slug}
                                is_external_url_with_reference={isExternalUrlWithReference}
                            />
                    )}
                    {shouldDisplayEventDetailsLink &&
                        <a
                            role="button"
                            tabIndex="0"
                            className="hs-event__details-link"
                            onClick={handleDetailsLinkClick}
                            onKeyDown={handleLinkKeyDownWithFunction(handleDetailsLinkClick)}
                        >
                            {labelDetailsButton}
                        </a>
                    }
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./components/event_list/default_event.jsx